import { useEffect } from 'react';

import { useAgentManager } from '../providers/AgentProvider';
import { useChatHistoryNodeStore } from '../store/useChatHistoryNodeStore';
import { useThreadMessages } from '../store/useChatStore';
import { extractChatHistoryNodes } from '../store/utils/extractChatHistoryNodes';

/** Syncs chat history tool results to the chat history node store for the current thread. */
export function useChatHistoryNodeSync() {
  const { currentThreadId } = useAgentManager();
  const messages = useThreadMessages(currentThreadId);

  useEffect(() => {
    if (!currentThreadId || messages.length === 0) {
      useChatHistoryNodeStore.getState().setNodes({});
      return;
    }

    const nodes = extractChatHistoryNodes(messages);
    useChatHistoryNodeStore.getState().setNodes(nodes);
  }, [currentThreadId, messages]);
}
